module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAAA5UlEQVRIS93VPwrCMBTH8e9v0MVbeAUnQQfBC3gKN2fpolsP4OgJnAUXRx28hGd5ktBCLdU0/QNioFPCJ++95iWipyHnmtkNmNXc4y5pHlqbwxZaWJiPhyX5jboYbxH/N2xmLtuxpGdV6RqXwsy2QOo+SUkZbwMvgQswqMIbw9n5XwGnKrwV/A0PwpFd6fbaSDr0ASeS0iAc6kIzWwBnYAQcgbUkfxbdJeTvitjO+4R6qylsZlPgWo40z7ANvAP2xfSLZWsDD4EJ8HA17azzQj+1ccS/AYeiyOajnqZ+HtOakUYtewGjH5sZIru+0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_sign out@2x.png
// module id = N9L5
// module chunks = 2